import * as React from "react";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import IconWrapper from "../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {RouteComponentProps, withRouter} from "react-router";
import "./linkPresenter.scss";

interface ComponentProps {
	/**
	 * Label.
	 */
	label: string;
	/**
	 * Url.
	 */
	url: string;
}

type Props = ComponentProps & RouteComponentProps<{}>;

/**
 * Link presenter.
 */
class LinkPresenter extends React.PureComponent <Props, {}> {
	render() {
		return (
			<>
				<div className="c-link-presenter" onClick={this.onClick}>{this.props.label}</div>
				<div className="c-link-presenter_icon">
					<IconWrapper size={12} variant={"burgundy"} icon={Icon.ExternalSmall} viewBoxFromSize={true}/>
				</div>
			</>
		);
	}

	onClick = (evt: React.MouseEvent<HTMLSpanElement>) => {
		evt.stopPropagation();
		window.open(this.props.url, "_blank")
	}
}

export default withRouter<ComponentProps>(LinkPresenter);
